<template>
  <section>
    <Feature :title="$t('RM_DISTRIBUTOR_MAINTAIN')" :iconClass="'fa-database'">
      <FormRow :fieldNameArr="[$t('RM_VENDOR'), $t('DISTRIBUTOR')]">
        <Select style="width: 200px;" v-model="rmVendorName" @on-change="changeRmVendor($event)"
          :placeholder="$t('CHOOSE')" slot="a">
          <Option v-for="(item) in rmVendors" :value="item.vendorName" :key="item.id">
            {{ item.vendorName }}
          </Option>
        </Select>
        <Select style="width: 200px;" v-model="distributorName" @on-change="changeDistributor($event)"
          :placeholder="$t('CHOOSE')" slot="b">
          <Option v-for="(item) in distributors" :value="item.vendorName" :key="item.id">
            {{ item.vendorName }}
          </Option>
        </Select>
      </FormRow>
      <ButtonRow>
        <Button type="primary" @click="search(true)" slot="0">{{ $t('COMMON_TEXT_SEARCH') }}</Button>
        <Button type="primary" @click="upload" slot="1">{{ $t('UPLOAD') }}</Button>
        <Button type="primary" @click="clear" slot="2">{{ $t('CLEAR') }}</Button>
      </ButtonRow>
      <TablePage :tableWidth="windowWidth" :columnsList="columnsList" :resultList="dataList" :pageObj="pageObj"
        @changePage="changePage" v-if="isData"></TablePage>
    </Feature>
    <Modal :z-index="modalSize" :reset-drag-position="true" @on-ok="uploadOk" @on-cancel="uploadCancel" sticky
      :draggable="true" v-model="model" :title="$t('UPLOAD')">
      <FormRow :fieldNameArr="['STEP1']">
        <Button icon="md-cloud-download" type="success" slot="a" @click="downloadSample">{{ $t('DOWNLOAD') }}</Button>
      </FormRow>
      <I style="color: red">Please use excel file, and the first row is column description which will not upload to
        system. Please input your data from second row.</I>
      <FormRow :fieldNameArr="['File Upload (File Size < 5MB)', file == null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadFile">{{ $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
    </Modal>
  </section>
</template>
  
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertDelete } from "@/util/alert"
import { Translate, ExceptionHandling } from "@/util/common"

export default {
  name: "RmDistributorMaintain",
  created() {
    const vueInstance = this
    vueInstance.search()

    SearchVendor(vueInstance, 'vendor').then(data => {
      vueInstance.rmVendors = data
    }).catch((error) => {
      AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      })
    })

    SearchVendor(vueInstance, 'distributor').then(data => {
      vueInstance.distributors = data
    }).catch((error) => {
      AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      })
    })
  },
  data() {
    return {
      model: false,
      rmVendors: [],
      rmVendor: {},
      rmVendorName: '',
      distributors: [],
      distributor: {},
      distributorName: '',
      file: null,
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('CATEGORY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "rmCategory",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RM_VENDOR_CODE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "vendorCode",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RM_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "vendorName",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RM_DISTRIBUTOR_CODE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "distributorCode",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RM_DISTRIBUTOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "distributorName",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REMARK')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "remark",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_GROUP_ACCOUNT')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "createAcount",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMMON_BUTTON_operation')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          maxWidth: 120,
          align: 'center',
          render: (h, params) => {
            return (
              <div class="cell-button-container">
                <Button
                  type="error"
                  shape="circle"
                  onClick={() => {
                    deleteDistributor(this, params.row)
                  }}
                  icon="ios-trash"></Button>
              </div>
            )
          },
        },
      ],
      dataList: []
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    clear() {
      this.rmVendor = {}
      this.rmVendorName = ''
      this.distributor = {}
      this.distributorName = ''
    },
    create() {
      this.search(true)
    },
    onchange() {
      this.search(true)
    },
    search(init) {
      let vueInstance = this
      if (init) {
        vueInstance.pageObj = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        }
      }
      vueInstance.toggleLoading(true)
      let data = {
        "vendorId": this.rmVendor ? this.rmVendor.uuid : "",
        "distributorId": this.distributor ? this.distributor.uuid : ""
      }
      vueInstance.$quotationHttp
        .post("/rm-distributor/search?page=" + vueInstance.pageObj.page + "&size=" + vueInstance.pageObj.pageSize, JSON.stringify(data))
        .then((response) => {
          vueInstance.dataList = []
          vueInstance.toggleLoading(false)
          if (response.data._embedded) {
            vueInstance.dataList = response.data._embedded.rmDistributorResourceList
            vueInstance.pageObj = {
              "page": response.data.page.number + 1,
              "totalPage": response.data.page.totalPages,
              "totalCount": response.data.page.totalElements,
              "pageSize": response.data.page.size
            }
          } else {
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => {
                return h('span', [
                  Translate("COMMON_TEXT_NOTHING")
                ])
              }
            });
          }
        })
        .catch((error) => {
          vueInstance.toggleLoading(false)
          let text = ExceptionHandling(error.response)
          vueInstance.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            html: text,
          })
        })
    },
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    uploadOk() {
      this.file = null
    },
    uploadCancel() {
      this.file = null
    },
    upload() {
      this.model = true
    },
    downloadSample() {
      this.$downloadMasterAttachment(this, 'RmDistributor')
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile() {
      let fd = new FormData()
      fd.append('file', this.file)
      this.toggleLoading(true)
      this.$quotationHttp
        .post("/rm-distributor/uploadExcel", fd)
        .then((response) => {
          this.file = null
          this.model = false
          this.search(true)
          this.$Swal.fire({
            icon: "info",
            title: Translate("COMMON_MESSAGE_SUCCESS"),
            text: response.data.content[0].status,
          })
        })
        .catch((error) => {
          this.toggleLoading(false)
          let text = ExceptionHandling(error.response)
          this.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            html: text,
          })
        })
    },
    changeRmVendor(value) {
      this.rmVendor = this.rmVendors.find(function (rmVendor) {
        return rmVendor.vendorName == value
      });
    },
    changeDistributor(value) {
      this.distributor = this.distributors.find(function (distributorVendor) {
        return distributorVendor.vendorName == value
      });
    },
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    },
    isData() {
      return this.dataList && this.dataList.length > 0
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  }
}


function SearchVendor(vueInstance, type) {
  return vueInstance.$quotationHttp
    .get("/rm-distributor/find/" + type)
    .then((response) => {
      if (response.data) {
        return response.data
      } else {
        vueInstance.$Notice.success({
          title: Translate("COMMON_MESSAGE_INFO"),
          desc: Translate("COMMON_MESSAGE_INFO"),
          render: h => {
            return h('span', [
              Translate("COMMON_TEXT_NOTHING")
            ])
          }
        });
      }
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}

function deleteDistributor(vueInstance, item) {
  AlertDelete(vueInstance, item.vendorCode)
    .then(() => {
      vueInstance.toggleLoading(true)
      return vueInstance.$quotationHttp
        .delete("/rm-distributor/" + item.uuid)
        .then((response) => {
          if (response.data) {
            vueInstance.dataList.splice(item._index, 1)
            vueInstance.toggleLoading(false)
          } else {
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => {
                return h('span', [
                  Translate("COMMON_TEXT_NOTHING")
                ])
              }
            });
          }
        })
        .catch((error) => {
          vueInstance.toggleLoading(false)
          let text = ExceptionHandling(error.response)
          vueInstance.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            html: text,
          })
        })
    })
    .catch(() => { })
}


</script>
  
<style scoped></style>
  